// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5c9e714d","833":"f40e2275"}[chunkId] + ".chunk.js";
};